import { Link as RouterLink } from "react-router-dom";
import { Box, Typography, styled } from "@mui/material";

import { useTranslation } from "@/lib/i18n";

type Props = {
  name: string;
  href: string;
  config: {
    // Description could be passed down from link-series
    description?: string;
  };
  showTitle?: boolean;
};

const StyledLink = styled(RouterLink)(({ theme }) => ({
  textDecoration: "underline",
  color: theme.palette.primary.main,

  "&:not([href^=mailto])[target=_blank]::after": {
    content:
      "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAQElEQVR42qXKwQkAIAxDUUdxtO6/RBQkQZvSi8I/pL4BoGw/XPkh4XigPmsUgh0626AjRsgxHTkUThsG2T/sIlzdTsp52kSS1wAAAABJRU5ErkJggg==)",
    margin: "0px 3px 0px 5px",
  },

  ":hover": {
    textDecoration: "none",
  },
}));

const StyledDescription = styled("small")(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  color: theme.palette.text.secondary,
}));

const Link = ({ name, href, config, showTitle = true }: Props) => {
  const { t } = useTranslation();
  const prefix = href.includes("://") ? "" : import.meta.env.VITE_API_BASE_PATH;
  const hrefWithBase = `${prefix}${href}`;

  return (
    <div>
      <Box>
        {showTitle && (
          <Typography fontWeight="bold" variant="h4" pb={1}>
            {name}
          </Typography>
        )}
        <StyledLink
          title="External Page"
          to={hrefWithBase}
          target="_blank"
          rel="noreferrer"
        >
          {name}
        </StyledLink>{" "}
        {t("common.openInNewTab")}
      </Box>
      {config.description && <StyledDescription>{config.description}</StyledDescription>}
    </div>
  );
};

export default Link;
